"use client";

import { useSyncNinetailedIdentity } from "@/hooks/useSyncNinetailedIdentity";
export function NinetailedIdentitySync() {
  useSyncNinetailedIdentity();
  return null;
}